<div class="p-6">
	<ui-content-header type="page" title="Document Requests">
		<ui-button
			*ngIf="canMakeRequests()"
			title-action
			label="New Request"
			icon="plus"
			preset="PRIMARY"
			(click)="openRequestFormDrawer()"
			data-intercom-target="document-requests-new-request-button"
		/>
	</ui-content-header>

	<div
		class="flex flex-col divide-y divide-gray-200 border rounded-xl border-gray-200 overflow-hidden bg-white"
	>
		<div class="grid grid-cols-12 p-4 bg-gray-50">
			<div class="col-span-5">
				<p class="p-xs text-gray-500">Requested By</p>
			</div>
			<div class="col-span-3">
				<p class="p-xs text-gray-500">Requested At</p>
			</div>
			<div class="col-span-2">
				<p class="p-xs text-gray-500"># of Files</p>
			</div>
			<div class="col-span-2">
				<p class="p-xs text-gray-500">Status</p>
			</div>
		</div>
		<div class="overflow-y-auto divide-y divide-gray-200">
			<ng-container *ngIf="documentRequests$ | async as documentRequests">
				@if (documentRequests.length > 0) {
					<ng-container *ngFor="let request of documentRequests">
						<div
							class="grid grid-cols-12 p-4 items-center hover:bg-gray-50 duration-300 cursor-pointer"
							(click)="openRequestDetails(request)"
						>
							<div class="col-span-5">
								<p class="p-sm">
									{{
										request.createdBy
											| businessUserNameById: request.createdById
									}}
								</p>
							</div>
							<div class="col-span-3">
								<p class="p-sm">{{ request.createdAt | date }}</p>
							</div>
							<div class="col-span-2">
								<p class="p-sm">{{ request.documentsCount }}</p>
							</div>
							<div class="col-span-2">
								<div
									class="px-3 py-1.5 rounded-md float-left border"
									[ngClass]="{
										'bg-amber-50 text-amber-800 border-amber-200':
											request.status === DocumentRequestStatus.PENDING,
										'bg-blue-50 text-blue-800 border-blue-200':
											request.status === DocumentRequestStatus.IN_PROGRESS,
										'bg-green-50 text-green-800 border-green-200':
											request.status === DocumentRequestStatus.COMPLETED,
										'bg-red-50 text-red-800 border-red-200':
											request.status === DocumentRequestStatus.CANCELED,
										'bg-gray-50 text-gray-800 border-gray-200':
											request.status === DocumentRequestStatus.ON_HOLD,
									}"
								>
									<p class="text-xs">{{ request.status | titlecase }}</p>
								</div>
							</div>
						</div>
					</ng-container>
				} @else {
					<div class="p-16 flex justify-center items-center">
						<p class="p-sm">No requests have been made yet.</p>
					</div>
				}
			</ng-container>
		</div>
	</div>
</div>
